// © Thibault Sabathier, 2025.
// frontend/src/utils/interventionRoles.js
//
// Constantes front « Je souhaite intervenir en tant que » (alumni, multi-valeurs).
// Aligné sur backend/config/interventionRoles.js (MÊMES clés, même ordre).
//
// ⚠️ Convention : la clé DB/API est `intervention_roles` (snake). Le front
// manipule le tableau de clés tel quel ; le libellé passe par i18n.
//
// Ajouter une clé → propager dans :
//   1. backend/config/interventionRoles.js (VALUES + migration si besoin)
//   2. cette liste (INTERVENTION_ROLE_VALUES)
//   3. i18n business:intervention_roles.<key> (fr/en/es)

export const INTERVENTION_ROLE_VALUES = [
  'jury',
  'surveillant',
  'enseignant',
  'conferencier',
  'correcteur',
  'tuteur',
  'jury_recrutement',
  'atelier',
]

// Libellé affichable d'un rôle. Avec `t` → i18n (business:intervention_roles.<key>).
export const getInterventionRoleLabel = (key, t) => {
  if (!key) return ''
  if (t) return t(`business:intervention_roles.${key}`, { defaultValue: key })
  return key
}
